
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contraloria-social",
      function () {
        return require("private-next-pages/contraloria-social/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contraloria-social"])
      });
    }
  